<template>
  <a-card :title="$t('announceList')"
      v-infinite-scroll="getBulletinList"
      :infinite-scroll-disabled="busy"
      :infinite-scroll-distance="5">
      <a-list :data-source="bulletinList">
        <a-list-item slot="renderItem" slot-scope="item, index">
          <a-list-item-meta>
            <a slot="title">{{ $dt(item,'NOTICE_NAME') }}</a>
            <div slot="description" style="
              overflow: hidden;
              text-overflow: ellipsis;
              " v-html="$dt(item,'CONTENT')"></div>
          </a-list-item-meta>
          <a @click="$router.push(`/bulletinDetail?NOTICE_ID=${item.NOTICE_ID}`)">{{ $t('detail') }}</a>
        </a-list-item>
        <div class="demo-loading-container" v-if="loading && !busy">
          <a-spin />
        </div>
      </a-list>
  </a-card>
</template>

<script>

export default {
  name: "bulletin",
  components: {},
  data(){
    return{
      bulletinList: [],
      loading: false,
      busy: false,
      pageNumber: 1,
      pageSize: 10
    }
  },
  methods:{
    getBulletinList(){
      this.loading = true;
      this.$h5Api({
        type: '1001',
        data: [this.$dotNetUtil.commonPageJson('GM_NOTICE', {SYS_TYPE: 20011003},this.pageNumber,this.pageSize,'NOTICE_ORDER ASC,CREATE_DATE DESC')],
      }).then(({data}) => {
        if(data?.DATA_LIST.length > 0){
          this.pageNumber += 1;
          this.bulletinList.push(...data?.DATA_LIST);
        }else {
          this.busy = true;
        }
      }).finally(() =>{
        this.loading = false;
      })
    }
  },
  created() {
  }
}
</script>

<style scoped>

.demo-loading-container {
  position: absolute;
  bottom: 40px;
  width: 100%;
  text-align: center;
}
</style>